import { gql } from '@apollo/client'

import {
  METADATA_NODE_FRAGMENT,
  SIMPLE_USER_FRAGMENT,
} from '../../../common/graphql/fragments'

import DISH_ADDITIONAL_INGREDIENT_FRAGMENT from './dish-additional-ingredient-fragment'
import DISH_CHOICE_INGREDIENT_FRAGMENT from './dish-choice-ingredient-fragment'
import DISH_MAIN_INGREDIENT_FRAGMENT from './dish-main-ingredient-fragment'

const DISH_LIST_FRAGMENT = gql`
  fragment DishListFragment on Dish {
    id
    autoeatId
    originalDishId
    menuId
    tier
    name
    description
    ingredients
    styledName
    styledDescription
    styledIngredients
    translatedName
    translatedDescription
    translatedIngredients
    lowPrice
    highPrice
    isPublished
    isDirty
    certainty
    dietDescriptors
    allergenDescriptors
    addonDescriptors
    miscDescriptors
    nutritionDescriptors
    isLocked
    lockedAt
    tierOneResolutionType
    menuTitle {
      id
      styledTitle
      styledDescription
    }
    diets {
      id
      name
      usedAiSuggestionMethod
    }
    allergens {
      id
      name
      usedAiSuggestionMethod
    }
    cuisineType {
      ...MetadataNodeFragment
    }
    dishType {
      ...MetadataNodeFragment
    }
    courseType {
      ...MetadataNodeFragment
    }
    mainIngredients {
      ...DishMainIngredientFragment
    }
    additionalIngredients {
      ...DishAdditionalIngredientFragment
    }
    choiceIngredients {
      ...DishChoiceIngredientFragment
    }
    blacklistedIngredients {
      ingredient {
        id
        name
      }
      word
      originField
      isSuggestedUsingMl
      isSuggestedUsingParser
      mlScore
      matchType
    }
    aiSuggestion {
      mainIngredients {
        certainty
        messages {
          level
          message
        }
        suggestion
      }

      dishType {
        messages {
          level
          message
        }
        suggestion {
          id
          score
          certainty
          matchType
          definiteResult
        }
      }

      cuisineType {
        messages {
          level
          message
        }

        suggestion {
          id
          score
        }
      }

      courseType {
        messages {
          level
          message
        }
        suggestion {
          id
          score
          certainty
          matchType
          definiteResult
        }
      }

      diets {
        certainty
        messages {
          level
          message
        }
        suggestion {
          id
          label
          score
          occurrences {
            word
            score
            dishId
            menuTitleId
            posIndex
            originField
          }
        }
      }

      allergens {
        certainty
        messages {
          level
          message
        }
        suggestion {
          id
          label
          score
          occurrences {
            word
            score
            dishId
            menuTitleId
            posIndex
            originField
          }
        }
      }
      miscAndChoice {
        certainty
        messages {
          level
          message
        }
        name {
          text
          score
        }
        description {
          text
          score
        }
        ingredients {
          text
          score
        }
      }
    }

    correction {
      styledName
      styledDescription
      styledIngredientsText
      dishTypeId
      courseTypeId
      mainIngredientIds
      additionalIngredientIds
      choiceIngredientIds
      dietIds
      allergenIds
    }
    isPublished
    isDeleted
    isFake
    isTierOneDone
    isCurationDone
    isQaDone
    isQcDone
    isEnabled
    isAiIgnored
    isManualIgnored
    createdAt
    autoeatUpdatedAt
    createdBy {
      ...SimpleUserFragment
    }
    updatedAt
    updatedBy {
      ...SimpleUserFragment
    }
    tierOneDoneAt
    tierOneDoneBy {
      ...SimpleUserFragment
    }

    curatedAt
    curatedBy {
      ...SimpleUserFragment
    }
    qadAt
    qadBy {
      ...SimpleUserFragment
    }
    qcdAt
    qcdBy {
      ...SimpleUserFragment
    }
    lastModifiedByTierOne {
      ...SimpleUserFragment
    }
    lastModifiedByCurator {
      ...SimpleUserFragment
    }
    lastModifiedByQa {
      ...SimpleUserFragment
    }
    lastModifiedByQc {
      ...SimpleUserFragment
    }
    lastModifiedByTierOneAt
    lastModifiedByCuratorAt
    lastModifiedByQaAt
    lastModifiedByQcAt
    lastRestSuggestionsAt
    lastPubSubSuggestionsAt
    miscAndChoiceUpdatedAt
    dishTypeUpdatedAt
    courseTypeUpdatedAt
    dietsUpdatedAt
    allergensUpdatedAt
    ingredientsUpdatedAt
    isPublishedUpdatedAt
  }
  ${DISH_ADDITIONAL_INGREDIENT_FRAGMENT}
  ${DISH_CHOICE_INGREDIENT_FRAGMENT}
  ${DISH_MAIN_INGREDIENT_FRAGMENT}
  ${SIMPLE_USER_FRAGMENT}
  ${METADATA_NODE_FRAGMENT}
`
export default DISH_LIST_FRAGMENT
